import React, { useEffect, useRef } from 'react';
import { SvgIcon } from '@/types';

export interface BareSvgProps extends React.SVGProps<SVGSVGElement> {
    SvgComponent: SvgIcon;
    removeFill?: boolean;
}

export const BareSvg: React.FC<BareSvgProps> = ({ SvgComponent, removeFill = false, ...props }) => {
    const svgRef = useRef<SVGSVGElement>(null);

    useEffect(() => {
        if (removeFill && svgRef.current) {
            const svg = svgRef.current;
            svg.querySelectorAll('*').forEach(el => {
                if (el instanceof SVGElement) {
                    el.removeAttribute('fill');
                    el.removeAttribute('stroke');
                }
            });
            svg.style.fill = 'currentColor';
        }
    }, [removeFill]);

    const style = removeFill ? { fill: 'currentColor', ...props.style } : props.style;

    return <SvgComponent ref={svgRef} style={style} {...props} />;
};
